var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4139 31V20.9811H24.7939L25.2963 17.0584H21.4139V14.5597C21.4139 13.4278 21.7293 12.6528 23.3539 12.6528H25.4125V9.15545C24.4109 9.04811 23.4041 8.99629 22.3968 9.00021C19.4092 9.00021 17.358 10.824 17.358 14.1722V17.051H14V20.9738H17.3653V31H21.4139Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWFacebook);
export default __webpack_public_path__ + "static/media/w_facebook.ee4de5a1f50e00b4b95a242c58c28352.svg";
export { ForwardRef as ReactComponent };